import { useCallback, useEffect, useState } from 'react'

const API_URL = import.meta.env.VITE_API_URL || '/v1'

/** Just enough of a user to pick and label them as a Bearbeiter. */
export interface AssignableUser {
  id: string
  username: string
  fullName: string
  initials: string | null
}

/**
 * The people a document can be assigned to. Reads /v1/users, which any signed-in
 * user may call — unlike /v1/admin/users, picking a Bearbeiter is not an admin task.
 */
export function useAssignableUsers() {
  const [users, setUsers] = useState<AssignableUser[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await fetch(`${API_URL}/users`, { credentials: 'include' })
      if (!res.ok) throw new Error('Nutzerliste konnte nicht geladen werden')
      const data = (await res.json()) as { users: AssignableUser[] }
      setUsers(data.users ?? [])
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Nutzerliste konnte nicht geladen werden')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void load()
  }, [load])

  return { users, loading, error, reload: load }
}
